module.exports = __webpack_public_path__ + "img/ton.dda4df29.png";